<template>
    <div class="row m-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p class="fs-12">Yang bertanda tangan di bawah ini, menerangkan bahwa:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">umur</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienAge }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienAddress }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">pekerjaan</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ IsLainLainSelected ? CustomPekerjaan : SelectedPekerjaan }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <VMultiSelect v-model="SelectedPekerjaan" :options="PekerjaanSurat"
                                                        :show-labels="false" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <template v-if="!CurrentlyPrintingLetter">
                            <tr v-if="IsLainLainSelected">
                                <td></td>
                                <td>

                                    <div class="d-flex align-items-center">
                                        <span class="mr-4">:</span>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <input v-model="CustomPekerjaan" type="text" class="form-control" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
                <div class="col-12 mt-4 mb-1">
                    <p class="mb-2 d-flex align-items-center">
                        <span class="mr-1 fs-12">Berdasarkan pemeriksaan tanggal</span>

                        <template v-if="CurrentlyPrintingLetter">
                            <span class="fs-12">
                                {{ TanggalPemeriksaan }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-auto">
                                <div class="d-flex flex-column">
                                    <date-picker :value-type="SuratDatePickerFormat()" v-model="TanggalPemeriksaan"
                                        :format="SuratDatePickerFormat()" type="date" placeholder="Tanggal Pemeriksaan"
                                        :clearable="false" input-class="form-control"></date-picker>
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </div>
                            </validation-provider>
                        </template>

                        <span class="ml-1 fs-12">
                            yang bersangkutan dinyatakan <strong class="text-uppercase">sehat</strong>
                        </span>.
                    </p>
                    <p class="d-flex align-items-center mb-2">
                        <span class="mr-1 fs-12"> Surat keterangan ini dibuat untuk keperluan </span>

                        <template v-if="CurrentlyPrintingLetter">
                            <span class="fs-12">
                                {{ KeperluanSurat }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="span" class="w-25">
                                <input v-model="KeperluanSurat" type="text" class="form-control"
                                    placeholder="Keperluan Surat">
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>
                    </p>
                </div>
                <div class="col-12">
                    <p style="margin-bottom: 14px" class="fs-12">
                        Demikian surat keterangan ini dibuat dengan sebenarnya dan dapat dipergunakan sebagaimana
                        mestinya.
                    </p>
                </div>

            </div>
        </div>

        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p class="text-capitalize fs-12" style="margin-bottom: 14px;">catatan:</p>
                </div>
                <div class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-4 fs-12" style="width: 15%">tinggi badan</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span v-if="PasienHeight && PasienHeight > 0" class="fs-12">
                                            {{ PasienHeight }} cm
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <input v-model="PasienHeight"
                                                            @keypress="OnlyNumericCommaAndDotInputOnKeypress" type="text"
                                                            class="form-control">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">cm</span>
                                                        </div>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-4 fs-12" style="width: 15%">berat badan</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span v-if="PasienWeight && PasienWeight > 0" class="fs-12">
                                            {{ PasienWeight }} kg
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <input v-model="PasienWeight"
                                                            @keypress="OnlyNumericCommaAndDotInputOnKeypress" type="text"
                                                            class="form-control">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">kg</span>
                                                        </div>
                                                    </div>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-4 fs-12" style="width: 15%">golongan darah</td>
                            <td>

                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ PasienGolonganDarah }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <VMultiSelect v-model="PasienGolonganDarah"
                                                        :options="GolonganDarahSurat" :show-labels="false" @input="changeGolonganDarah($event)" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-4 fs-12" style="width: 15%">tekanan darah</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span v-if="(PasienDiastole && PasienDiastole > 0) || PasienSystole && PasienSystole > 0" class="fs-12">
                                            {{ PasienSystole }}/{{ PasienDiastole }} mm/Hg
                                        </span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else>
                                        <div class="w-100">
                                            <div class="row">
                                                <div class="col-4 position-relative">
                                                    <div class="input-group flex-nowrap d-flex align-items-center">
                                                        <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                                            <input @keypress="OnlyNumericCommaAndDotInputOnKeypress"
                                                                type="text" v-model="PasienSystole"
                                                                style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                                                                class="form-control" />
                                                            <span class="text-danger position-absolute">{{ errors[0]
                                                            }}</span>
                                                        </validation-provider>

                                                        <div class="input-group-append">
                                                            <span class="input-group-text px-2">/</span>
                                                        </div>

                                                        <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                                            <input @keypress="OnlyNumericCommaAndDotInputOnKeypress"
                                                                type="text" v-model="PasienDiastole"
                                                                class="form-control rounded-0" />
                                                            <span class="text-danger position-absolute"
                                                                :style="{ left: !PasienDiastole ? '50%' : '' }">{{ errors[0]
                                                                }}</span>
                                                        </validation-provider>

                                                        <div class="input-group-append">
                                                            <span class="input-group-text px-2">mm/Hg</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-4 fs-12" style="width: 15%">buta warna</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ SelectedButaWarna }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <div class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                                        <VMultiSelect v-model="SelectedButaWarna" :options="ButaWarnaSurat"
                                                            :show-labels="false" />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-12" style="margin-top: 2px">
            <div class="row">
                <div class="col-12">
                    <p class="fs-12">{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12 mt-4 pt-4">
                    <p class="mb-1 fs-12">{{ DokterInformation.DokterName }}</p>
                    <p class="fs-12">{{ DokterInformation.DokterSIP }}</p>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign :increaseFont="true" />
        </div>
    </div>
</template>

<script>
import "vue2-datepicker/index.css";;
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDatePicker, SuratDatePickerFormat } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'
import { OnlyNumericCommaAndDotInputOnKeypress } from '../../Helpers/InputEvent.js'
import { PekerjaanCustom } from '../../Helpers/PekerjaanSurat.js'

export default {
    name: 'SuratSehatBody',
    components: {
        DatePicker: () => import('vue2-datepicker'),
        VMultiSelect: () => import('vue-multiselect'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            PasienName: null,
            PasienAge: null,
            PasienSex: null,
            PasienAddress: null,
            SelectedPekerjaan: null,
            CustomPekerjaan: null,
            TanggalPemeriksaan: null,
            KeperluanSurat: null,
            PasienHeight: null,
            PasienWeight: null,
            PasienSystole: null,
            PasienDiastole: null,
            PasienGolonganDarah: null,
            SelectedButaWarna: null,
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                        if (key == 'PasienJob' && this.checkValueData(val[key])) {
                            this.SelectedPekerjaan = val[key];
                            if (this.IsLainLainSelected) this.CustomPekerjaan = val[`${key}Custom`];
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        },
        pasienGolonganDarah: {
            handler: function (val) {
                if (this.$route.fullPath.includes('/klinik/rekam-medis')) {
                    this.PasienGolonganDarah = val && val == 'N' ? 'Tidak Diketahui' : val;
                }
            },
            deep: true,
            immediate: true
        },
    },
    mounted() {
        this.TanggalPemeriksaan = SuratDatePicker()

        this.$nextTick(() => {
            this.$emit('ComponentMounted')
        })
    },
    computed: {
        ...mapState(['rm']),
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'TransKlinikIDFromPembayaran', 'LetterID', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'PekerjaanSurat', 'GolonganDarahSurat', 'ButaWarnaSurat', 'TransKlinikID']),
        ...mapGetters('rm', ['pasienGolonganDarah']),
        IsLainLainSelected() {
            return this.SelectedPekerjaan === 'Lain-lain'
        },
        SuratSehatEndpoint() {
            return `${this.API_URL}/surat-sehat`
        },
        PayloadBackend() {
            return {
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                jenisKelaminPasien: this.PasienSex,
                alamatPasien: this.PasienAddress,
                pekerjaanPasien: this.IsLainLainSelected ? this.CustomPekerjaan : this.SelectedPekerjaan,
                tanggalPeriksaPasien: this.TanggalPemeriksaan,
                keperluanSuratPasien: this.KeperluanSurat,
                tinggiBadanPasien: this.PasienHeight,
                beratBadanPasien: this.PasienWeight,
                golonganDarahPasien: this.PasienGolonganDarah,
                sistolePasien: this.PasienSystole,
                diastolePasien: this.PasienDiastole,
                butaWarnaPasien: this.SelectedButaWarna,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber
            }
        }
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        ...mapActions(['updateTandaVital']),
        PekerjaanCustom,
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        OnlyNumericCommaAndDotInputOnKeypress,
        async GetData() {
            this.SET_LOADING(true)

            this.$nextTick(async () => {
                const { data } = await this.$axios.get(`${this.SuratSehatEndpoint}/${this.LetterID}`);

                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.PasienAddress = this.checkValueData(data.alamat_pasien) ? data.alamat_pasien : ''
                this.SelectedPekerjaan = this.PekerjaanCustom(data.pekerjaan_pasien)
                this.CustomPekerjaan = this.SelectedPekerjaan === 'Lain-lain' ? data.pekerjaan_pasien : null

                this.TanggalPemeriksaan = data.tanggal_periksa_pasien
                this.KeperluanSurat = data.keperluan_surat_pasien
                this.PasienHeight = data.tinggi_badan_pasien
                this.PasienWeight = data.berat_badan_pasien
                this.PasienGolonganDarah = data.golongan_darah_pasien
                this.PasienSystole = data.sistole_pasien
                this.PasienDiastole = data.diastole_pasien
                this.SelectedButaWarna = data.buta_warna_pasien

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })
        },
        async UpdateData() {
            const { data } = await this.$axios.put(`${this.SuratSehatEndpoint}/${this.LetterID}`, this.PayloadBackend);
            return data;
        },
        async SaveData() {
            const { data } = await this.$axios.post(`${this.SuratSehatEndpoint}/create`, this.PayloadBackend);
            return data;
        },
        changeGolonganDarah($event) {
            const val = $event == 'Tidak Diketahui' ? 'N' : $event;
            this.$store.commit('rm/SET_PASIEN_GOL_DARAH', val);
            this.updateTandaVital({ key: 'golongan_darah', value: val })
        },
    }
}
</script>

<style lang="scss">
.surat-sehat {
    .table {
        td {
            padding-top: 0;
            padding-bottom: 14px;
        }
    }
}

// .fs-12 {
//     font-size: 16pt !important;
// }
</style>